<!-- add-unit.component.html -->
<div class="unit-form-container">
  
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p class="loading-text">{{ loadingMessage }}</p>
    </div>
  </div>

  <div class="form-header">
    <h1>إضافة وحدة جديدة</h1>
    <p>أدخل بيانات الوحدة الجديدة في النموذج أدناه</p>
  </div>

  <form [formGroup]="unitForm" class="unit-form" [class.loading]="isLoading">
    
    <div class="form-section">
      <h2>المعلومات الأساسية</h2>
      
      <div class="form-row">
        <!-- الاسم العربي -->
        <div class="form-group" [class.error]="isFieldInvalid('arName')">
          <label for="arName">الاسم بالعربية *</label>
          <input 
            type="text" 
            id="arName"
            formControlName="arName" 
            placeholder="أدخل الاسم باللغة العربية"
            [class.error]="isFieldInvalid('arName')"
            [disabled]="isLoading"
          />
          <div class="error-message" *ngIf="isFieldInvalid('arName')">
            ⚠️ {{ getFieldError('arName') }}
          </div>
        </div>

        <!-- الاسم الإنجليزي -->
        <div class="form-group" [class.error]="isFieldInvalid('enName')">
          <label for="enName">الاسم بالإنجليزية *</label>
          <input 
            type="text" 
            id="enName"
            formControlName="enName" 
            placeholder="أدخل الاسم باللغة الإنجليزية"
            [class.error]="isFieldInvalid('enName')"
            [disabled]="isLoading"
            (blur)="generateCode()"
          />
          <div class="error-message" *ngIf="isFieldInvalid('enName')">
            ⚠️ {{ getFieldError('enName') }}
          </div>
        </div>
      </div>

      <div class="form-row">
       

        <!-- الكود -->
        <div class="form-group" [class.error]="isFieldInvalid('code')">
          <label for="code">كود الوحدة *</label>
          <input 
            type="text" 
            id="code"
            formControlName="code" 
            placeholder="أدخل كود الوحدة"
            [class.error]="isFieldInvalid('code')"
            [disabled]="isLoading"
            style="text-transform: uppercase;"
          />
          <div class="error-message" *ngIf="isFieldInvalid('code')">
            ⚠️ {{ getFieldError('code') }}
          </div>
          <small class="form-text">كود مختصر للوحدة (اتركه فارغا اذا اردت ان يساوي ال id)</small>
        </div>
          <div class="form-group" [class.error]="isFieldInvalid('type')">
          <label for="code">نوع الوحدة *</label>
          <select
            id="type"
            formControlName="type"
            [class.error]="isFieldInvalid('type')"
            [disabled]="isLoading"
          >
            <option disabled>اختر النوع</option>
            <option value="1">وحدة</option>
            <option value="0">وزن</option>
          </select>

          <div class="error-message" *ngIf="isFieldInvalid('type')">
            ⚠️ {{ getFieldError('type') }}
          </div>
          <small class="form-text">اختر نوع الوحدة (وحدة أو وزن)</small>
        </div>
      </div>

  
    </div>

    <!-- معاينة البيانات -->
    <div class="preview-section" *ngIf="unitForm.valid">
      <h3>معاينة البيانات</h3>
      <div class="preview-card">
        <div class="preview-row">
          <span class="preview-label">الاسم العربي:</span>
          <span class="preview-value">{{ unitForm.get('arName')?.value }}</span>
        </div>
        <div class="preview-row">
          <span class="preview-label">الاسم الإنجليزي:</span>
          <span class="preview-value">{{ unitForm.get('enName')?.value }}</span>
        </div>
        <div class="preview-row">
          <span class="preview-label">الكود:</span>
          <span class="preview-value">{{ unitForm.get('code')?.value }}</span>
        </div>
        <div class="preview-row">
          <span class="preview-label">الوحدة:</span>
          <span class="preview-value">{{ unitForm.get('type')?.value == 1 ? "وحدة" : "وزن" }}</span>
        </div>
      </div>
    </div>

    <!-- أزرار التحكم -->
    <div class="form-actions">
      <button 
        type="button" 
        class="btn-cancel" 
        (click)="onCancel()"
        [disabled]="isLoading">
        إلغاء
      </button>
      
      <button 
        type="button" 
        class="btn-reset" 
        (click)="onReset()"
        [disabled]="isLoading">
        إعادة تعيين
      </button>
      
      <button 
        type="button" 
        class="btn-save" 
        (click)="onSubmit()"
        [disabled]="isLoading">
        <span *ngIf="!isLoading">إنشاء الوحدة</span>
        <span *ngIf="isLoading">جاري الإنشاء...</span>
      </button>
    </div>

  </form>
</div>